import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
  fillColor?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
}

export function LockIcon({
  fillColor = 'currentColor',
  width = 16,
  height = 16,
  className = '',
  ...props
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='6 4 12 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 10.6701C7 10.3019 7.29848 10.0034 7.66667 10.0034H16.3333C16.7015 10.0034 17 10.3019 17 10.6701V18.0034C17 18.3716 16.7015 18.6701 16.3333 18.6701H7.66667C7.29848 18.6701 7 18.3716 7 18.0034V10.6701ZM8.33333 11.3368V17.3368H15.6667V11.3368H8.33333Z'
        fill={fillColor}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.40402 6.07394C10.0917 5.38631 11.0243 5 11.9967 5C12.9692 5 13.9018 5.38631 14.5895 6.07394C15.2771 6.76158 15.6634 7.69421 15.6634 8.66667V10.6667H14.3301V8.66667C14.3301 8.04783 14.0842 7.45434 13.6467 7.01675C13.2091 6.57917 12.6156 6.33333 11.9967 6.33333C11.3779 6.33333 10.7844 6.57917 10.3468 7.01675C9.90924 7.45434 9.66341 8.04783 9.66341 8.66667V10.6667H8.33008V8.66667C8.33008 7.69421 8.71639 6.76158 9.40402 6.07394Z'
        fill={fillColor}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 13.0034C12.3682 13.0034 12.6667 13.3019 12.6667 13.6701V15.0034C12.6667 15.3716 12.3682 15.6701 12 15.6701C11.6319 15.6701 11.3334 15.3716 11.3334 15.0034V13.6701C11.3334 13.3019 11.6319 13.0034 12 13.0034Z'
        fill={fillColor}
      />
    </svg>
  );
}

export default LockIcon;
